export function objectToNVP(obj) {
    if (Array.isArray(obj)) {
        throw new Error('Array types not supported');
    }
    return Object.entries(obj).map(([name, value]) => {
        return { name, value };
    });
}
export function nvpToObject(nvps) {
    return nvps.reduce((a, v) => (Object.assign(Object.assign({}, a), { [v.name]: v.value })), {});
}
//# sourceMappingURL=objectToNVP.js.map